import type { ITranslationsAuth } from '../translations/translations.interface';

let translations: ITranslationsAuth | null = null;

const loadingCompletion = new Promise<void>(async (resolve) => {
  translations = (await import('../translations/translations.en')).translations;
  resolve();
});

export let translationsService = {
  get loadingCompleted() {
    return loadingCompletion;
  },
  get translations(): ITranslationsAuth {
    if (translations === null) {
      throw Error('Translations not fetched yet');
    }

    return translations;
  },
};

// TODO: refetching after language change and emitting the event
